var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MglMarker',{ref:"marker",attrs:{"coordinates":_vm.coordinates,"draggable":_vm.isDraggable,"offset":[-12, -35]},on:{"dragend":_vm.dragEnd}},[_c('template',{slot:"marker"},[_c('MarkerUI',{attrs:{"point":_vm.point,"is-selected":_vm.isSelected,"has-edit-permission":_vm.hasEditPermission}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }